import Reactions from "../models/Reactions";

const ReactionsStore = Reactions.create();

export default ReactionsStore;
